import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

export const KebijakanPrivasi = () => {
  const [lang, setLang] = useState("id");

  useEffect(() => {
    try {
      const stored = localStorage.getItem("privacy_lang");
      if (stored === "id" || stored === "en") setLang(stored);
    } catch (e) {
      // ignore
    }
    window.scrollTo(0, 0);
  }, []);

  const setLanguage = (l) => {
    if (l !== "id" && l !== "en") return;
    setLang(l);
    try {
      localStorage.setItem("privacy_lang", l);
    } catch (e) {
      // ignore
    }
  };

  const content = {
    id: {
      body: (
        <>
          <h3 className="text-lg font-bold text-slate-700 mb-4">
            Kebijakan Privasi
          </h3>

          <div className="text-md text-gray-700 space-y-4">
            <p>
              Selamat datang di website resmi{" "}
              <strong>Mountain Marathon Festival</strong> di alamat{" "}
              <a
                href="https://mountainmarathonfestival.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-700 underline"
              >
                mountainmarathonfestival.com
              </a>
              .
            </p>

            <p>
              Kami sangat menghargai privasi Anda. Kebijakan Privasi ini
              menjelaskan bagaimana kami mengumpulkan, menggunakan, menyimpan,
              dan melindungi informasi pribadi yang Anda berikan saat
              menggunakan website ini. Dengan mengakses atau menggunakan website
              ini, Anda menyetujui praktik yang dijelaskan dalam Kebijakan
              Privasi ini.
            </p>

            <h4 className="text-md font-semibold text-slate-700">
              Informasi yang Kami Kumpulkan
            </h4>
            <p>Kami dapat mengumpulkan informasi berikut:</p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                Informasi yang Anda berikan secara sukarela, seperti nama
                lengkap, alamat email, nomor telepon, tanggal lahir, jenis
                kelamin, dan data lain saat mendaftar event, mengisi formulir,
                atau menghubungi kami.
              </li>
              <li>
                Informasi otomatis seperti alamat IP, jenis browser, perangkat,
                sistem operasi, dan data penggunaan website melalui cookie serta
                teknologi serupa.
              </li>
            </ul>

            <h4 className="text-md font-semibold text-slate-700">
              Penggunaan Informasi
            </h4>
            <p>Informasi yang kami kumpulkan digunakan untuk:</p>
            <ul className="list-disc pl-5 space-y-2">
              <li>Memproses pendaftaran dan pembayaran event</li>
              <li>
                Mengirimkan konfirmasi pendaftaran, race pack, dan informasi
                penting terkait event
              </li>
              <li>
                Meningkatkan kualitas layanan dan pengalaman pengguna di website
              </li>
              <li>
                Mengirimkan newsletter, pengumuman event mendatang, atau promosi
                (dengan persetujuan Anda)
              </li>
              <li>Mematuhi kewajiban hukum yang berlaku</li>
            </ul>

            <h4 className="text-md font-semibold text-slate-700">
              Berbagi Informasi
            </h4>
            <p>
              Kami tidak menjual atau menyewakan data pribadi Anda kepada pihak
              ketiga. Kami hanya akan membagikan informasi Anda kepada:
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                Penyedia layanan tepercaya (payment gateway, email service,
                hosting) yang membantu operasional kami
              </li>
              <li>Pihak berwenang jika diwajibkan oleh hukum</li>
              <li>Partner resmi event (dengan persetujuan Anda sebelumnya)</li>
            </ul>

            <h4 className="text-md font-semibold text-slate-700">
              Cookie dan Teknologi Pelacakan
            </h4>
            <p>
              Website ini menggunakan cookie untuk meningkatkan pengalaman
              pengguna, analitik, dan fungsionalitas. Anda dapat mengatur
              preferensi cookie melalui pengaturan browser Anda.
            </p>

            <h4 className="text-md font-semibold text-slate-700">
              Keamanan Data
            </h4>
            <p>
              Kami menerapkan langkah-langkah keamanan teknis dan organisasional
              yang wajar untuk melindungi data Anda dari akses, perubahan, atau
              pengungkapan yang tidak sah. Namun, tidak ada sistem yang 100%
              aman.
            </p>

            <h4 className="text-md font-semibold text-slate-700">Hak Anda</h4>
            <p>Anda berhak untuk:</p>
            <ul className="list-disc pl-5 space-y-2">
              <li>Mengakses data pribadi yang kami simpan</li>
              <li>Meminta koreksi atau penghapusan data</li>
              <li>Menarik persetujuan kapan saja</li>
              <li>Mengajukan keluhan ke otoritas perlindungan data</li>
            </ul>

            <h4 className="text-md font-semibold text-slate-700">
              Perubahan Kebijakan Privasi
            </h4>
            <p>
              Kami dapat memperbarui Kebijakan Privasi ini dari waktu ke waktu.
              Perubahan akan dipublikasikan di halaman ini dengan tanggal
              pembaruan terbaru.
            </p>

            <h4 className="text-md font-semibold text-slate-700">
              Kontak Kami
            </h4>
            <p>
              Jika Anda memiliki pertanyaan mengenai Kebijakan Privasi ini,
              silakan hubungi kami melalui email:{" "}
              <a
                href="mailto:mountainmarathonfestival@gmail.com"
                className="text-slate-700 underline"
              >
                mountainmarathonfestival@gmail.com
              </a>
            </p>
          </div>
        </>
      ),
    },
    en: {
      body: (
        <>
          <h3 className="text-lg font-bold text-slate-700 mb-4">
            Privacy Policy
          </h3>

          <div className="text-md text-gray-700 space-y-4">
            <p>
              Welcome to the official website of{" "}
              <strong>Mountain Marathon Festival</strong> at{" "}
              <a
                href="https://mountainmarathonfestival.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-700 underline"
              >
                mountainmarathonfestival.com
              </a>
              .
            </p>

            <p>
              We value your privacy. This Privacy Policy explains how we
              collect, use, store, and protect the personal information you
              provide when using this website. By accessing or using the
              website, you agree to the practices described in this Privacy
              Policy.
            </p>

            <h4 className="text-md font-semibold text-slate-700">
              Information We Collect
            </h4>
            <p>We may collect the following information:</p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                Information you provide voluntarily, such as full name, email
                address, phone number, date of birth, gender, and other data
                when registering for an event, filling out forms, or contacting
                us.
              </li>
              <li>
                Automatically collected information such as IP address, browser
                type, device, operating system, and website usage data through
                cookies and similar technologies.
              </li>
            </ul>

            <h4 className="text-md font-semibold text-slate-700">
              How We Use Your Information
            </h4>
            <p>The information we collect is used to:</p>
            <ul className="list-disc pl-5 space-y-2">
              <li>Process event registrations and payments</li>
              <li>
                Send registration confirmations, race pack details, and other
                important event-related information
              </li>
              <li>Improve our services and website user experience</li>
              <li>
                Send newsletters, event announcements, or promotions (with your
                consent)
              </li>
              <li>Comply with applicable legal obligations</li>
            </ul>

            <h4 className="text-md font-semibold text-slate-700">
              Sharing Information
            </h4>
            <p>
              We do not sell or rent your personal data to third parties. We may
              share your information with:
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                Trusted service providers (payment gateways, email services,
                hosting) who assist our operations
              </li>
              <li>Authorities where required by law</li>
              <li>Official event partners (with your prior consent)</li>
            </ul>

            <h4 className="text-md font-semibold text-slate-700">
              Cookies and Tracking Technologies
            </h4>
            <p>
              This website uses cookies to enhance user experience, analytics,
              and functionality. You can manage your cookie preferences through
              your browser settings.
            </p>

            <h4 className="text-md font-semibold text-slate-700">
              Data Security
            </h4>
            <p>
              We implement reasonable technical and organizational measures to
              protect your data from unauthorized access, alteration, or
              disclosure. However, no system is 100% secure.
            </p>

            <h4 className="text-md font-semibold text-slate-700">
              Your Rights
            </h4>
            <p>You have the right to:</p>
            <ul className="list-disc pl-5 space-y-2">
              <li>Access the personal data we hold about you</li>
              <li>Request correction or deletion of your data</li>
              <li>Withdraw consent at any time</li>
              <li>File a complaint with a data protection authority</li>
            </ul>

            <h4 className="text-md font-semibold text-slate-700">
              Changes to This Privacy Policy
            </h4>
            <p>
              We may update this Privacy Policy from time to time. Any changes
              will be posted on this page with the most recent update date.
            </p>

            <h4 className="text-md font-semibold text-slate-700">Contact Us</h4>
            <p>
              If you have any questions about this Privacy Policy, please email
              us at{" "}
              <a
                href="mailto:mountainmarathonfestival@gmail.com"
                className="text-slate-700 underline"
              >
                mountainmarathonfestival@gmail.com
              </a>
              .
            </p>
          </div>
        </>
      ),
    },
  };

  return (
    <section className="w-full min-h-screen py-20 bg-white text-slate-700">
      <div className="container mx-auto max-w-6xl">
        <div className="max-w-6xl mx-auto space-y-6">
          {/* Language switcher (top-right) */}
          <div className="flex px-4 justify-end">
            <div
              className="inline-flex rounded-md shadow-sm"
              role="group"
              aria-label="Language switcher"
            >
              <button
                onClick={() => setLanguage("id")}
                aria-pressed={lang === "id"}
                className={`px-4 py-1 text-sm font-medium transition ${
                  lang === "id"
                    ? "bg-slate-700 text-white rounded-l-md"
                    : "bg-white text-slate-700 border border-slate-200 rounded-l-md"
                }`}
              >
                Bahasa (ID)
              </button>
              <button
                onClick={() => setLanguage("en")}
                aria-pressed={lang === "en"}
                className={`px-4 py-1 text-sm font-medium transition ${
                  lang === "en"
                    ? "bg-slate-700 text-white rounded-r-md"
                    : "bg-white text-slate-700 border border-slate-200 rounded-r-md"
                }`}
              >
                English
              </button>
            </div>
          </div>

          <div className="max-w-6xl mx-auto">
            <motion.div
              className="text-left"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <div className="px-4 py-6 md:px-8 md:py-8">
                <div className="prose prose-lg max-w-none text-gray-700">
                  {content[lang].body}
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KebijakanPrivasi;
